interface DarkColors {
  [key: string]: string
}

export const INPUT_BACKGROUND_COLOR_DARK = '#002433'

export const INPUT_BACKGROUND_COLOR_LIGHT = '#dfebeb'

export const DARK_THEME_BACKGROUND_CLASSES = Object.freeze({
  'Brilliance Black': 'bg-brilliance-black',
  'Iris Dark': 'bg-iris-dark',
  'Night Owl': 'bg-night-owl',
  'Oceanic Next': 'bg-oceanic-next',
  Cobalt: 'bg-cobalt',
  Monokai: 'bg-monokai',
  Sunburst: 'bg-sunburst',
}) as Readonly<Record<string, string>>

export const themesBackgroundColors: DarkColors = {
  'Iris Dark': '#200020',
  Cobalt: '#002240',
  Monokai: '#272822',
  'Night Owl': '#011627',
  'Oceanic Next': '#1B2B34',
  'Brilliance Black': '#000000',
  Sunburst: '#000000',
}

export const saveUserTheme = (theme: string) => {
  localStorage.setItem('iris_user_theme', theme)
}

export const themedStyle = ({
  themeName,
  lightColor,
  isDarkTheme,
}: {
  themeName: string
  lightColor?: string
  isDarkTheme: boolean
}) => ({
  backgroundColor: themesBackgroundColors[themeName],
  color: isDarkTheme ? 'whitesmoke' : lightColor,
})

export const availableDarkThemes = [
  'Brilliance Black',
  'Cobalt',
  'Monokai',
  'Night Owl',
  'Oceanic Next',
  'Sunburst',
  'Iris Dark',
]

export const availableLightThemes = ['Active4D', 'Clouds', 'Dawn', 'Iris default', 'Katzenmilch', 'Solarized-light']

export const themeLoaders = {
  Amy: () => import('monaco-themes/themes/Amy.json'),
  'Brilliance Black': () => import('monaco-themes/themes/Brilliance Black.json'),
  Cobalt: () => import('monaco-themes/themes/Cobalt.json'),
  Monokai: () => import('monaco-themes/themes/Monokai.json'),
  'Night Owl': () => import('monaco-themes/themes/Night Owl.json'),
  'Oceanic Next': () => import('monaco-themes/themes/Oceanic Next.json'),
  Sunburst: () => import('monaco-themes/themes/Sunburst.json'),
  Active4D: () => import('monaco-themes/themes/Active4D.json'),
  Clouds: () => import('monaco-themes/themes/Clouds.json'),
  Dawn: () => import('monaco-themes/themes/Dawn.json'),
  Katzenmilch: () => import('monaco-themes/themes/Katzenmilch.json'),
  'Solarized-light': () => import('monaco-themes/themes/Solarized-light.json'),
}
